import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Box,
  Tooltip,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { styles } from "./UserInputForm.styles";
import { FONT_SIZES } from "../../constants/fontSizes";

const TOP_50_TLDS = [
  ".com",
  ".org",
  ".net",
  ".io",
  ".ai",
  ".co",
  ".app",
  ".dev",
  ".xyz",
  ".info",
  ".me",
  ".us",
  ".uk",
  ".ca",
  ".de",
  ".jp",
  ".fr",
  ".au",
  ".in",
  ".nl",
  ".br",
  ".ru",
  ".ch",
  ".se",
  ".no",
  ".es",
  ".gr",
  ".at",
  ".be",
  ".pl",
  ".ir",
  ".cn",
  ".sg",
  ".edu",
  ".gov",
  ".mil",
  ".int",
  ".arpa",
  ".onion",
  ".space",
  ".tech",
  ".online",
  ".store",
  ".blog",
  ".guru",
  ".club",
  ".today",
  ".news",
  ".world",
  ".site",
];

const TldCheckboxDropdown = ({ selectedTlds, onChange, disabled }) => {
  const [open, setOpen] = useState(false);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    onChange(value);
  };

  return (
    <Tooltip
      title="Select the top-level domains you want to check for availability"
      arrow
      placement="right"
      enterDelay={200}
      leaveDelay={0}
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: FONT_SIZES.TEXT_HINT.xs,
            "@media (min-width: 600px)": {
              fontSize: FONT_SIZES.TEXT_HINT.sm,
            },
          },
        },
      }}
    >
      <FormControl
        fullWidth
        size="small"
        variant="standard"
        sx={styles.textField}
      >
        <InputLabel
          id="tld-checkbox-label"
          htmlFor="tld-checkbox"
          sx={{
            ...styles.tldLabel,
            fontSize: FONT_SIZES.PARAGRAPH.xs,
            "@media (min-width: 600px)": {
              fontSize: FONT_SIZES.PARAGRAPH.sm,
            },
          }}
        >
          Preferred Top Level Domains (ex: .com, .net, .org)
        </InputLabel>
        <Select
          labelId="tld-checkbox-label"
          id="tld-checkbox"
          multiple
          value={selectedTlds}
          onChange={handleChange}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          disabled={disabled}
          label="Preferred Top Level Domains (ex: .com, .net, .org)"
          renderValue={(selected) => (
            <Box
              sx={{
                ...styles.tldSelectedValue,
                fontSize: FONT_SIZES.PARAGRAPH.xs,
                "@media (min-width: 600px)": {
                  fontSize: FONT_SIZES.PARAGRAPH.sm,
                },
              }}
            >
              {selected.length > 0
                ? `${selected.length} selected: ${selected
                    .slice(0, 3)
                    .join(", ")}${selected.length > 3 ? "..." : ""}`
                : "Select TLDs"}
            </Box>
          )}
          sx={styles.tldDropdown}
          endAdornment={<InfoIcon color="action" sx={styles.infoIcon} />}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 300,
                width: 250,
              },
            },
          }}
        >
          {TOP_50_TLDS.map((tld) => (
            <MenuItem key={tld} value={tld} sx={{ minHeight: "32px" }}>
              <Checkbox checked={selectedTlds.indexOf(tld) > -1} size="small" />
              <ListItemText
                primary={tld}
                primaryTypographyProps={{
                  fontSize: FONT_SIZES.PARAGRAPH,
                }}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Tooltip>
  );
};

export default TldCheckboxDropdown;
